import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import SupportPage from './pages/SupportPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <nav className="bg-white shadow-sm sticky top-0 z-50">
          <div className="container mx-auto px-4">
            <div className="flex items-center justify-between h-16">
              <Link to="/" className="text-2xl font-bold text-green-600">
                NutriLens Pro
              </Link>
              <div className="flex space-x-6">
                <Link to="/" className="text-gray-700 hover:text-green-600 font-medium">
                  Home
                </Link>
                <Link to="/privacy" className="text-gray-700 hover:text-green-600 font-medium">
                  Privacy
                </Link>
                <Link to="/terms" className="text-gray-700 hover:text-green-600 font-medium">
                  Terms
                </Link>
                <Link to="/support" className="text-gray-700 hover:text-green-600 font-medium">
                  Support
                </Link>
              </div>
            </div>
          </div>
        </nav>
        
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/support" element={<SupportPage />} />
          </Routes>
        </main>

        <footer className="bg-white border-t mt-16">
          <div className="container mx-auto px-4 py-8">
            <div className="text-center text-gray-600">
              <p className="mb-2">© 2025 NutriLens Pro. All rights reserved.</p>
              <div className="flex justify-center space-x-4 text-sm">
                <Link to="/privacy" className="hover:text-green-600">Privacy Policy</Link>
                <span>•</span>
                <Link to="/terms" className="hover:text-green-600">Terms of Service</Link>
                <span>•</span>
                <Link to="/support" className="hover:text-green-600">Support</Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;